<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="商家角色名称" name="keyword"></c-form-item>
					<c-form-item type="datetime" label="创建时间" start-name="dateMin" end-name="dateMax"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button color="sys" @click="navigateTo('/stationed_auth_add')">新建商家角色</c-button>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="商家角色名称"
					name="auth_name"
					width="150"
				>
				</c-table-column>
				
				<c-table-column
					label="发布商品审核"
					name="is_product_check"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.is_product_check == 1" style="color: green;">不需要</span>
						<span v-if="data.is_product_check == 2" style="color: red;">需要</span>
					</template>
				
				</c-table-column>
				
				<c-table-column label="运营模式" name="operation_mode" width="100">
					<template v-slot="{data}">
						<span v-if="data.operation_mode == 1">平台运营</span>
						<span v-if="data.operation_mode == 2">商家自营</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="平台盈利模式"
					name="platform_profit_model"
					width="260"
				>
					<template v-slot="{data}">
						<span v-if="data.platform_profit_model == 1">向商家抽取服务费</span>
						<span v-if="data.platform_profit_model == 2" style="color: red;">平台加价销售</span>
					</template>
				
				</c-table-column>
				
				<c-table-column
					label="是否开通店铺"
					name="is_open_shop"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.is_open_shop == 1" style="color: red;">无店铺</span>
						<span v-if="data.is_open_shop == 2">开通店铺</span>
					</template>
				
				</c-table-column>
				
				<c-table-column label="结算账户类型" name="settlement_account_type" width="110">
					<template v-slot="{data}">
						<span v-if="data.settlement_account_type == 1">平台统收账户</span>
						<span v-if="data.settlement_account_type == 2">商家独立账户</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="描述"
					name="remark"
					width="260"
				>
				</c-table-column>
				
				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				>
				</c-table-column>
				
				<c-table-column
					label="更新时间"
					name="update_date"
					width="140"
				>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/stationed_auth_edit/${data.id}`)">编辑</c-table-button>
						<c-table-button @click="deleteHandle(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
	</page>
</template>

<script>
	export default {
		name: 'm_srm_auth',
		
		data() {
			return {
				powerList: []
			}
		},
		
		computed: {
			powerAllCheck() {
				return !!(this.powerList.length && !this.powerList.find(item => item.checked == 0));
			}
		},
		
		mounted() {
			this.$refs.search.search();
			this.$bus.$on('authList.update', page => {
				this.$refs.table.update(page);
			});
		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 1;
				this.$refs.table.load({
					url: '/stationed/auth/list',
					data
				});
			},

			deleteHandle(data) {
				this.$confirm({
					text: '确定要删除【'+data.auth_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/stationed/auth/delete',
							data: {
								auth_id: data.id,
							},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},

			checkPower(item, state) {
				if (item == 'all') {
					this.powerList.forEach(item => {
						this.checkPower(item, state);
					});
				} else {
					item.checked = state ? 1 : 0;
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.power {
		height: 300px;
		overflow: auto;
		
		&-list {
			clear: both;
			overflow: hidden;
			
			.power-list {
				margin-left: 40px;
				margin-bottom: 20px;
			}
		}
		
		&-item {
			float: left;
			margin-top: 15px;
			margin-left: 20px;
		}
	}
</style>